import { parsePost, type BlogPostData } from '@/lib/blogFormat';

/**
 * Every post is a markdown file in this folder. Adding a post means adding a
 * file; the list page, the post page, the prerendered HTML and the sitemap all
 * pick it up from here (the prerenderer reads the same files from disk).
 */
const files = import.meta.glob('./*.md', { query: '?raw', import: 'default', eager: true }) as Record<string, string>;

export const posts: BlogPostData[] = Object.entries(files)
  .map(([file, src]) => parsePost(src, file))
  .sort((a, b) => b.date.localeCompare(a.date) || a.title.localeCompare(b.title));

export const getPost = (slug: string) => posts.find((p) => p.slug === slug);
